import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';
import { StaticImage } from 'gatsby-plugin-image';

interface SectionNewProps {
	title: string;
	subtitle?: string;
	intro?: string;
	isCentered?: boolean;
	hasBackground?: boolean;
	children: React.ReactNode;
	className?: string;
	containerClassName?: string;
	id?: string;
}

export function SectionNew({
	title,
	subtitle,
	intro,
	isCentered = true,
	hasBackground = false,
	children,
	className,
	containerClassName,
	id,
}: SectionNewProps) {
	return (
		<section className={cn(hasBackground && 'relative', className)} id={id}>
			<div className={cn('container', containerClassName)}>
				<div className={cn('relative flex flex-col', isCentered && 'items-center')}>
					<div
						className={cn(
							'flex flex-col',
							isCentered ? 'mx-auto items-center text-center' : 'text-left',
						)}
					>
						{subtitle ? (
							<p className="max-w-[50ch] text-balance text-xl font-semibold text-primary-500">
								{subtitle}
							</p>
						) : null}
						<h2 className="mt-1 max-w-[60ch] text-balance text-3xl font-semibold text-secondary-700">
							{title}
						</h2>
						{intro ? (
							<p className="mt-4 max-w-[80ch] text-pretty text-xl text-secondary-700">{intro}</p>
						) : null}
					</div>
					{children}
				</div>
			</div>
			{hasBackground ? (
				<div className="absolute inset-0 -z-20 opacity-35">
					<StaticImage
						src="../../static/images/hero_background.png"
						alt=""
						className="h-full w-full"
					/>
				</div>
			) : null}
		</section>
	);
}
